import ResponsiveHelper from "../utils/ResponsiveHelper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { Fancybox } from "@fancyapps/ui";
import Swiper from "swiper/bundle";

export default class Silder {
  constructor(dom) {
    window.addEventListener("resize", () => this.resize());
    this.dom = dom

    this.el_id = Math.floor(Math.random() * 99999)
    this.dom.dataset.id = this.el_id
  }

  init() {
    const type = this.dom.dataset.type

    switch (type) {
      case '_home-slider':
        this.homeSlider()
        break;
      case '_related-posts':
      case '_image-details':
        this.relatedPosts()
        break;

      case '_gallery':
        this.gallery()
        break;

      case '_gallery-1_1':
        this.gallery_1_1()
        break;

      default:
        break;
    }

    // ScrollTrigger.refresh()
    setTimeout(() => {
      ScrollTrigger.refresh()
    }, 1000)
  }

  homeSlider() {
    let currentVideos = [];
    const loopTime = this.dom.dataset.loopTime ? parseInt(this.dom.dataset.loopTime) * 1000 : 4000; // Default to 4000ms if not set
    
    // Helper: set the correct src based on viewport and load the video
    const loadAndGetVideo = (slide) => {
      const video = slide.querySelector('video');
      if (!video) return null;

      const isMobile = window.innerWidth < 768;
      const src = (isMobile && video.dataset.mobileSrc)
        ? video.dataset.mobileSrc
        : video.dataset.desktopSrc;

      if (src) {
        const source = video.querySelector('source');
        if (source && source.src !== src) {
          source.src = src;
          video.load();
        }
      }

      return video;
    };

    let homeSlider = new Swiper(this.dom.querySelector('.home-slider'), {
      allowTouchMove: false,
      spaceBetween: 0,
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      effect: "fade",
      autoplay: {
        delay: loopTime,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: this.dom.querySelector('.btn-next'),
      },
      on: {
        init: (swiper) => {
          swiper.el.classList.remove('www-slider-loading')
          const currentSlide = swiper.slides[swiper.activeIndex];
          const activeVideo = loadAndGetVideo(currentSlide);
          currentVideos = [activeVideo];
          
          if (activeVideo) {
            activeVideo.currentTime = 0;
            activeVideo.play();
          }
          
          if (swiper.slides.length == 1) {
            setInterval(() => {
              const video = loadAndGetVideo(currentSlide);
              if (video) {
                video.currentTime = 0;
                video.play();
              }
            }, loopTime);
          }
        },
        slideChangeTransitionStart: (swiper) => {
          // console.log('slideChangeTransitionStart', swiper.activeIndex);
          
          // Pause all current videos
          currentVideos.forEach(video => {
            if (video) {
              video.pause();
              setTimeout(() => {
                video.currentTime = 0;
              }, 1000);
            }
          });

          // Load and play the active video in the current slide
          const currentSlide = swiper.slides[swiper.activeIndex];
          const activeVideo = loadAndGetVideo(currentSlide);
          currentVideos = [activeVideo];
          
          if (activeVideo) {
            activeVideo.play();
          }
        },
        slideChangeTransitionEnd: (swiper) => {
          // console.log('slideChangeTransitionEnd', swiper.activeIndex);
          // Get all videos
          const videos = this.dom.querySelectorAll('.swiper-slide video');
          
          // Pause all videos
          // videos.forEach(video => {
          //   video.pause();
          // });

          // Play the video in the current slide from the beginning
          // const currentSlide = swiper.slides[swiper.activeIndex];
          // if (currentSlide.querySelector('video')) {
          //   currentVideo = currentSlide.querySelector('video')
          //   currentVideo.currentTime = 0;
          //   currentVideo.play();
          // }
        }
      },
      
    });

    // Add ended event to all videos
    const videos = this.dom.querySelectorAll('.swiper-slide video');

    videos.forEach(video => {
      // When a video ends, move to the next slide
      video.addEventListener('ended', function() {
        // Only trigger slide change if this is the currently active slide's video
        const currentSlide = homeSlider.slides[homeSlider.activeIndex];
        if (currentSlide.contains(this)) {
          homeSlider.slideNext();
        }
      });
      
      // Set to loop for preview purposes (will still trigger 'ended' event)
      // video.loop = true;
    });

    // Handle window resize — only reload video when breakpoint actually crosses 768px
    let wasMobile = window.innerWidth < 768;
    const handleResize = () => {
      const isMobile = window.innerWidth < 768;
      if (isMobile === wasMobile) return;
      wasMobile = isMobile;

      const currentSlide = homeSlider.slides[homeSlider.activeIndex];
      const video = currentSlide.querySelector('video');
      if (!video) return;

      const src = (isMobile && video.dataset.mobileSrc)
        ? video.dataset.mobileSrc
        : video.dataset.desktopSrc;

      if (src) {
        const source = video.querySelector('source');
        currentVideos.forEach(v => { if (v) { v.pause(); v.currentTime = 0; } });
        source.src = src;
        video.load();
        video.play().catch(() => {});
        currentVideos = [video];
      }
    };

    // Debounce resize handler to avoid excessive calls
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, 300);
    });

    // Override default navigation button behavior
    // this.dom.querySelector('.btn-next').addEventListener('click', function(e) {
    //   e.stopPropagation();
    //   // console.log(homeSlider)
    //   const currentVideo = homeSlider.slides[homeSlider.previousIndex].querySelector('video');
    //   if (currentVideo) {
    //     // currentVideo.pause();
    //     // currentVideo.currentTime = currentVideo.duration - 0.1; // Almost at the end
    //   }
    // });
  } 

  relatedPosts() {
    let thumbSlider = new Swiper(this.dom.querySelector('.thumb-slider'), {
      spaceBetween: 5,
      slidesPerView: 2.2,
      breakpoints: {
        769: {
          spaceBetween: 5,
          slidesPerView: 5.2,
        }
      },
      navigation: {
        nextEl: this.dom.querySelector('.btn-next'),
        prevEl: this.dom.querySelector('.btn-prev'),
      },
      on: {
        init: (swiper) => {
          swiper.el.classList.remove('www-slider-loading')
          
        }
      },
      
    });
  }

  gallery() {
    let index_text = this.dom.querySelector('.indexs span')
    let thumbSlider = new Swiper(this.dom.querySelector('.thumb-slider'), {
        lazy: true,
      spaceBetween: 10,
      slidesPerView: 1,
      freeMode: false,
      breakpoints: {
        769: {
            slidesPerView: 'auto',
            freeMode: true
        }
      },
      navigation: {
        nextEl: this.dom.querySelector('.btn-next'),
        prevEl: this.dom.querySelector('.btn-prev'),
      },
      on: {
        init: (swiper) => {
          swiper.el.classList.remove('www-slider-loading')
        }
      }
    });
    
    thumbSlider.on('slideChange', (swiper) => {
      // console.log(swiper.realIndex);
      // select_slide_active.style.setProperty("--index", swiper.realIndex);
      index_text.innerHTML = swiper.realIndex + 1
    })

    Fancybox.bind(this.dom, "[data-fancybox]", {
      // Your custom options
    });
  }

  gallery_1_1() {
    let index_text = this.dom.querySelector('.indexs span')
    let thumbSlider = new Swiper(this.dom.querySelector('.thumb-slider'), {
        lazy: true,
      spaceBetween: 10,
      slidesPerView: 1,
      navigation: {
        nextEl: this.dom.querySelector('.btn-next'),
        prevEl: this.dom.querySelector('.btn-prev'),
      },
      on: {
        init: (swiper) => {
          swiper.el.classList.remove('www-slider-loading')
        }
      }
    });
    
    thumbSlider.on('slideChange', (swiper) => {
      // console.log(swiper.realIndex);
      // select_slide_active.style.setProperty("--index", swiper.realIndex);    
      index_text.innerHTML = swiper.realIndex + 1
    })

    Fancybox.bind(this.dom, "[data-fancybox]", {
      // Your custom options
    });
  }

  trailerSlider() {
    let trailerSlider = new Swiper(this.dom.querySelector('.trailers'), {
      spaceBetween: 20,
      slidesPerView: 1.5,
      breakpoints: {
        769: {
          spaceBetween: 40,
          slidesPerView: 2.5,
        }
      },
    });
  }

  initResponsiveHelper() {

  }

  resize() {
  }

}
